module.exports = __webpack_public_path__ + "img/Koken op vuur.b8ec4648.jpg";